import { render, staticRenderFns } from "./Disclaimer.html?vue&type=template&id=389e1e43&scoped=true&"
import script from "./Disclaimer.ts?vue&type=script&lang=ts&"
export * from "./Disclaimer.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/body/_body.scss?vue&type=style&index=0&id=389e1e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e1e43",
  null
  
)

export default component.exports